module.exports = __webpack_public_path__ + "images/crowd-teaser-e5ab1239f716e48d4faed65d2be7e4b0.png";